import { render, staticRenderFns } from "./ExtensionCard.vue?vue&type=template&id=6cce4976&scoped=true"
import script from "./ExtensionCard.vue?vue&type=script&lang=js"
export * from "./ExtensionCard.vue?vue&type=script&lang=js"
import style0 from "./ExtensionCard.vue?vue&type=style&index=0&id=6cce4976&prod&lang=scss&scoped=true"
import style1 from "./ExtensionCard.vue?vue&type=style&index=1&id=6cce4976&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cce4976",
  null
  
)

export default component.exports